export const CartMixin = {
    name: "CartMixin",
    computed: {
        items() {
            return this.$store.state.cart.items;
        },
        totals() {
            return this.$store.state.cart.totals;
        }
    }
}
